export default "__VITE_ASSET__4d7ab5db__"